import { Grid, SxProps, Theme, useMediaQuery, useTheme } from "@mui/material";
import { ReactNode } from "react";
import PaperComponent from "./PaperComponent";

interface ICardsProps {
  width?: number | string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const Cards = ({ children, width, sx }: ICardsProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <PaperComponent
      sx={{
        ...sx,
        width: !matches ? "100%" : width ? width : 800,
      }}
    >
      <Grid container alignItems={"center"} sx={{ p: 2 }}>
        {children}
      </Grid>
    </PaperComponent>
  );
};

export default Cards;
